import React, {ChangeEvent, SetStateAction, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {ErrorToast} from "../../../shared/toasters/toasters";
import {Card, Col, Row} from "react-bootstrap";
import {IJob} from "../interface";
import {AdminJobService} from "../service";
import DatePicker from "react-datepicker";
import {PICTURE_URL} from "../../../helpers/api.routes";

interface IProps {
    state: IJob | null;
    setState: React.Dispatch<SetStateAction<IJob | null>>;
    setImage: React.Dispatch<SetStateAction<File | null>>;
}

const CreateForm = ({state, setState, setImage}: IProps) => {
    const {t} = useTranslation();
    const {id} = useParams();
    const navigate = useNavigate();

    function handleChange(event: ChangeEvent<HTMLInputElement>, isNumber = false) {
        const {name, value, valueAsNumber} = event.target;
        setState((prev) => ({...prev, [name]: isNumber ? valueAsNumber : value}) as IJob);
    }

    const switchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev) => ({...prev, [e.target.name]: e.target.checked}) as IJob);
    };

    const fileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        setImage(file as File)
    };

    useEffect(() => {
      id &&  AdminJobService.getSingle(+id!)
            .then((response) => {
                const {data} = response;
                setState(data);
            })
            .catch(ErrorToast);
    }, [id]);
    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col md={4}>
                        <label htmlFor="title">
                            {t("global.title")}
                        </label>
                        <input type="text"
                               name={'title'}
                               value={state?.title}
                               onChange={handleChange}
                               className={'form-control'}
                               required
                        />
                    </Col>
                    <Col md={4} className={'mb-3'}>
                        <label htmlFor="url">
                            {t("global.url")}
                        </label>
                        <input type="text"
                               name={'url'}
                               value={state?.url}
                               onChange={handleChange}
                               className={'form-control'}
                               required
                        />
                    </Col>
                    <Col md={2}>
                        <label htmlFor="date">
                            {t("global.date")}
                        </label>
                        <div className="datepicker-container">
                            <DatePicker
                                className="date-picker"
                                dateFormat="dd/MM/yyyy"
                                selected={state?.date && new Date(state?.date)}
                                onChange={(date) =>
                                    setState((prev: any) => ({...prev, date: date}))
                                }
                                isClearable
                                placeholderText={t('global.choose_date')}
                                required
                            />
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="d-flex flex-column form-check form-switch p-0">
                            <label htmlFor="active">
                                {t("global.active")}
                            </label>
                            <input
                                className="form-check-input switch-custom ms-0 mt-2"
                                type="checkbox"
                                name={"active"}
                                checked={state?.active}
                                onChange={switchHandler}
                                role="switch"
                                id="active"
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <label htmlFor="companyName">
                            {t("global.companyName")}
                        </label>
                        <input type="text"
                               name={'companyName'}
                               value={state?.companyName}
                               onChange={handleChange}
                               className={'form-control'}
                               required
                        />
                    </Col>
                    <Col md={4}>
                        <label htmlFor="location">
                            {t("global.location")}
                        </label>
                        <input type="text"
                               name={'location'}
                               value={state?.location}
                               onChange={handleChange}
                               className={'form-control'}
                               required
                        />
                    </Col>
                    <Col md={4}>
                        <label htmlFor="engagement">
                            {t("global.engagement")}
                        </label>
                        <input type="text"
                               name={'engagement'}
                               value={state?.engagement}
                               onChange={handleChange}
                               className={'form-control'}
                               required
                        />
                    </Col>
                    <Col md={12} className="mt-2">
                        <label htmlFor="imageFile">{t("global.image")}</label>
                        <input
                            onChange={(e) => fileHandler(e)}
                            className="form-control"
                            type="file"
                            accept="image/*"
                            id="imageFile"
                        />
                        {state?.image && (
                            <img
                                className="mt-3 rounded show-img-form"
                                alt="200x200"
                                src={PICTURE_URL + state?.image?.path}
                                data-holder-rendered="true"
                            />
                        )}
                    </Col>
                    <Col md={12} className={'d-flex align-items-end justify-content-end mt-3'}>
                        <button
                            className="btn btn-info me-3"
                            type={"button"}
                            onClick={() => navigate("/admin/jobs")}
                        >
                            {t("global.cancel")}
                        </button>
                        <button className="btn btn-primary" type="submit">
                            {t(state?.id ? "global.update" : "global.create")}
                        </button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default CreateForm;